import { useQuery } from '@apollo/client';
import { FetchGuestNotificationsDocument } from '@website/types/graphqlOperations';
import { useMemo } from 'react';
import ErrorPage from '../utilities/ErrorPage';
import LoadingPage from '../utilities/LoadingPage';
import Notifications from './Notifications';
import combineGuestAndHostsNotificationsObjects from './utils/combineGuestAndHostsNotificationsObjects';

type Props = {
  userID: string;
};

export default function GuestNotifications({ userID }: Props) {
  const { loading, error, data } = useQuery(FetchGuestNotificationsDocument, {
    variables: {
      userID,
    },
    fetchPolicy: 'cache-and-network',
  });

  // combine Guests and Host notifications before sending the data to the Notifications
  // rendering component. This affects users who manage hosts and want to view a
  // combined notification dashboard.
  const combinedNotifications = useMemo(() => {
    return combineGuestAndHostsNotificationsObjects(data?.user);
  }, [data]);

  if (loading && !data) {
    return <LoadingPage />;
  }

  if (error && !data) {
    return <ErrorPage />;
  }

  return <Notifications notifications={combinedNotifications} />;
}
